import { createContext } from 'react';

export type SegmentProfileTab = 'overview' | 'synthetic' | 'files' | 'message_generator';

export interface SegmentProfileTabContextValue {
  activeTab: SegmentProfileTab;
  setActiveTab: (tab: SegmentProfileTab) => void;
  chatOpen: boolean;
  setChatOpen: (open: boolean) => void;
}

export const SegmentProfileTabContext = createContext<SegmentProfileTabContextValue | null>(null);
SegmentProfileTabContext.displayName = 'SegmentProfileTabContext';
